import BaseService from '../baseService'

export class Service extends BaseService {
  getEligibilityVerifications() {
    return this.client.get('eligibility-verifications').json()
  }
}
